<template>
    <b-button-group class="mx-1" size="sm">
        <b-button @click.prevent="add"
                  variant="secondary"><i class="la la-plus"></i>
        </b-button>
    </b-button-group>
</template>
<script>
export default {
    name: 'BtnAddProduct',
    props: {
        value: {},
        province_name: {}
    },
    methods: {
        add() {
            if (!Array.isArray(this.value[this.province_name])) {
                this.$set(this.value, this.province_name, [])
            }

            this.value[this.province_name].push({
                tariffa_codice: null,
                warranty_codice: null,
                discount_rules_id: null,
                eta_max_veicolo: 0,
                eta_min_conducente: 18,
                provvigione: 0,
                provvigione_rinnovo: 0,
                sconto_bersani: 0,
                sconto_max: 0,
                sconto_rc_familiare: 0,
            })
        },
    }
}
</script>
